import { FC, useEffect, useMemo, useState } from "react";
import { useApp } from "../../AppContext";
import { InvestmentAccountsOverviewGetResponse } from "ApiClient/models";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Card, Header, LoadingError } from "@kaladel/react/Components";
import { Link } from "react-router";
import styles from "./HomeCards.module.scss";
import { DisplayCurrency } from "../DisplayCurrency";
import { convertCurrencies } from "Helpers/ExchangeHelpers";
import { useApiClient } from "Contexts/ApiClientContext";

export const InvestmentsCard: FC = () => {
    const { api, apiCall } = useApiClient();
    const { activeCurrency, exchangeRates } = useApp();

    const [investmentsOverview, setInvestmentsOverview] = useState<InvestmentAccountsOverviewGetResponse | null>(null);

    const refreshInvestmentsOverview = async () => {
        const response = await apiCall(() => api.investmentaccounts.overview.get());

        if (response.kind === "success") {
            setInvestmentsOverview(response.value);
        }
    };

    const totalValue = useMemo(() => {
        if (!activeCurrency || !exchangeRates || !investmentsOverview) return null;
        const currentCurrency = investmentsOverview.balances.find(b => b.currencyId === activeCurrency);
        if (!currentCurrency) return null;

        return convertCurrencies(currentCurrency.currencyBalances, activeCurrency, exchangeRates);
    }, [activeCurrency, exchangeRates, investmentsOverview]);

    useEffect(() => {
        refreshInvestmentsOverview();
    }, []);

    if (!activeCurrency) return null;

    return (
        <Card>
            <Header title={<Link to="investments">Investments <FontAwesomeIcon icon={faChevronRight} /></Link>} level={1} />

            <LoadingError
                value={totalValue}
                loaded={totalValue => (
                    <div className={styles.breakdown}>
                        <div className={styles.line}>
                            <div className={styles.title}>
                                Total Balance
                            </div>
                            <div className={styles.percentage}></div>
                            <div className={styles.value}>
                                <DisplayCurrency currencyCode={activeCurrency} value={totalValue} />
                            </div>
                        </div>
                    </div>
                )}
            />
        </Card>
    );
};